import { Component } from '@angular/core';

@Component({
    selector: 'inka-mascot-happy',
    templateUrl: './mascot-happy.component.html',
    styleUrls: ['./mascot-happy.component.scss'],
    standalone: false
})
export class MascotHappyComponent {

}
